import './ProfileGraphs.less';

import React from 'react';
import clsx from 'clsx';
import i18n from '../../../common/i18n';
import { Progress } from '../../graphs/Radial';

function ProfileGraphs({ evaluatedBets, successfulBets, evaluatedTickets, successfulTickets, simplified }) {
    const successRateRounded = evaluatedBets === 0 ? 0 : Math.round((successfulBets / evaluatedBets) * 1000) / 10;
    return (
        <div
            className={clsx('flex items-center justify-center p-rel flex-row', {
                'betbook-profile-graphs-box py-30': !simplified
            })}
        >
            <div
                className={clsx('flex items-center justify-center flex-col', {
                    'betbook-profile-graph-tickets-box': !simplified
                })}
            >
                <div
                    className={clsx('betbook-profile-graph-bets', {
                        'betbook-profile-no-graph p-rel': simplified
                    })}
                >
                    <Progress
                        progress={successRateRounded}
                        radius={35}
                        hole={30}
                        fill="#b2b2b2"
                        showLabel
                        classThresholds={[
                            ['base', 0],
                            ['smoliar', 31],
                            ['priemer', 61],
                            ['top', 100]
                        ]}
                    />
                </div>
                <div
                    className={clsx('p-rel text-center pt-5', {
                        'betbook-profile-success-box': simplified
                    })}
                >
                    <div className="betbook-profile-success-bets-text fs-13">
                        {i18n('nui.betbook.profile.bet.success')}
                    </div>
                    <div
                        className={clsx('betbook-profile-success-bets-count text-bold', {
                            'fs-13': simplified,
                            'fs-16': !simplified
                        })}
                    >
                        {`${successfulBets} z ${evaluatedBets}`}
                    </div>
                </div>
            </div>
            <div
                className={clsx(
                    'flex items-center justify-center flex-col',
                    simplified ? 'mx-20' : 'betbook-profile-graph-tickets-box'
                )}
            >
                <div
                    className={clsx('betbook-profile-graph-tickets', {
                        'betbook-profile-no-graph p-rel': simplified
                    })}
                >
                    <Progress
                        progress={evaluatedTickets === 0 ? 0 : (100 * successfulTickets) / evaluatedTickets}
                        radius={35}
                        hole={30}
                        fill="#b2b2b2"
                        showLabel
                        classThresholds={[
                            ['base', 0],
                            ['smoliar', 33],
                            ['priemer', 66],
                            ['top', 100]
                        ]}
                    />
                </div>
                <div
                    className={clsx('p-rel text-center pt-5', {
                        'betbook-profile-success-box': simplified
                    })}
                >
                    <div className="betbook-profile-success-tickets-text fs-13">
                        {i18n('nui.betbook.profile.ticket.success')}
                    </div>
                    <div
                        className={clsx('betbook-profile-success-tickets-count text-bold', {
                            'fs-13': simplified,
                            'fs-16': !simplified
                        })}
                    >
                        {successfulTickets + ' z ' + evaluatedTickets}{' '}
                    </div>
                </div>
            </div>
        </div>
    );
}

export default ProfileGraphs;
